import { Component, Input, Output, EventEmitter, Inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { setting } from '../../../../setting';

@Component({
  selector: 'usb-base-modal',
  templateUrl: '../base-modal/base-modal.component.html',
  styleUrls: ['../base-modal/base-modal.component.scss']
})

export class UsbBaseModalComponent {
  @Input() icon: string = '';
  @Input() title: string = '';
  @Input() subtitle: string = '';
  @Input() message: string = '';
  @Input() showCancelButton: boolean = true;
  @Input() confirmText: string = 'Si';
  @Input() cancelText: string = 'No';
  @Input() size: 'sm' | 'lg' | 'xl' = 'lg';
  @Input() titleReverse: boolean = false;

  @Output() confirm = new EventEmitter<void>();
  @Output() decline = new EventEmitter<void>();

  public getClientsSettingAppBooking: any;
  confirmResult: Subject<boolean> = new Subject<boolean>();
  bsModalRef: BsModalRef;

  constructor(@Inject(BsModalRef) bsModalRef: BsModalRef) {
    this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
    this.bsModalRef = bsModalRef;
  }

  confirmAction(): void {
    this.confirmResult.next(true);
    this.confirm.emit();
    if (this.bsModalRef) {
      this.bsModalRef.hide();
    }
  }

  declineAction(): void {
    this.confirmResult.next(false);
    this.decline.emit();
    if (this.bsModalRef) {
      this.bsModalRef.hide();
    }
  }

  onOverlayClick(event: Event): void {
    // Do nothing - overlay click doesn't close modal
  }
}
